import React from 'react';
import TextInput from '../basic/TextInput';
import Button from '../basic/Button';

class LockScreen extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const p = this.props;
        return (
            <div className="container">
                <div className="passcode_wrapper">
                    <div className="row">
                        <i className="fa fa-lock fa-5x passcode_lock_icon" aria-hidden="true"/>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <TextInput 
                                name={p.name + "Password"}
                                id={p.name + "pwd"}
                                type="Password"
                                floatingLabelText="Enter Passcode"
                                maxLength={20}
                                autoFocus={true}
                                fullWidth={true} 
                                floatingLabelStyle={{ color:"rgb(185,185,185)" }}
                            />
                        </div> {/* .col */}
                    </div> {/* .row */}
                    <div className="row">
                        <div className="col-lg-12">
                            <Button 
                                label="Unlock"
                                className="passcode_unlock_btn"
                            />
                        </div> {/* .col */}
                    </div> {/* .row */}
                </div> {/* .passcode_wrapper */}
            </div>
        );
    }
}

export default LockScreen;